import { Image } from "@react-three/drei";
import { getLocaleAsset } from "@tosize/ui";
import { useCabinetStore } from "../../../../context/StoreContext";
import { useCanvasStore } from "../../../../hooks/useCanvasStore";
import LineComponent from "../../utils/Line";
import SizePill from "../../utils/SizePill";

export const FIGURE_WIDTH = 668;
export const FIGURE_HEIGHT = 1805;

export function Figure() {
	const { state } = useCabinetStore();
	const { showDimensions, fullScreen } = useCanvasStore();

	const width = FIGURE_WIDTH / 1000;
	const height = FIGURE_HEIGHT / 1000;

	const line = 0.025;
	const lineOffset = 0.045;

	const fromX = 0.15;
	const fromY = 0;
	const fromZ = 0.001;

	const x = state.width / 1000 + width / 2 + fromX;

	if (fullScreen) {
		return null;
	}

	return (
		<>
			<Image
				transparent
				color={0x000000}
				opacity={0.1}
				toneMapped={false}
				position={[x, height / 2 - fromY, fromZ]}
				scale={[width, height]}
				url={getLocaleAsset("tosize_furniture/TOSIZEFurniture_silhouette_v3.png")}
			/>

			{showDimensions && (
				<>
					<LineComponent
						start={[x - lineOffset + line, 0, fromZ * 2]}
						end={[x - lineOffset - line, 0, fromZ * 2]}
					/>
					<LineComponent
						start={[x - lineOffset, 0, fromZ * 2]}
						end={[x - lineOffset, height - fromY, fromZ * 2]}
					>
						<SizePill
							variant="height"
							size={1800}
							position={{ x: x - lineOffset, y: (height - fromY) / 2, z: fromZ * 2 }}
						/>
					</LineComponent>
					<LineComponent
						start={[x - lineOffset + line, height - fromY, fromZ * 2]}
						end={[x - lineOffset - line, height - fromY, fromZ * 2]}
					/>
				</>
			)}
		</>
	);
}
